import { render, staticRenderFns } from "./MyMembership.vue?vue&type=template&id=55e33e41"
import script from "./MyMembership.vue?vue&type=script&lang=js"
export * from "./MyMembership.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports